export class PageVisibilityService {
    // The window is somewhere on the screen - not necessarily focused, but probably not minimized
    isVisible$ = new Rx.BehaviorSubject<boolean>(!document.hidden);

    // Window is the active window in system's window manager
    isWindowFocused$ = new Rx.BehaviorSubject<boolean>(document.hasFocus());

    get isWindowFocused() {
        return this.isWindowFocused$.getValue();
    }

    get isVisible() {
        return this.isVisible$.getValue();
    }

    constructor() {
        document.addEventListener('visibilitychange', () => {
            this.isVisible$.onNext(!document.hidden);
        });

        window.addEventListener('blur', () => {
            this.isWindowFocused$.onNext(false);
        });
        window.addEventListener('focus', () => {
            this.isWindowFocused$.onNext(true);
        });
    }
}

angular.module('tradersyard').service('PageVisibilityService', PageVisibilityService);
